module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checkIn goals"
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    attrs: {
      "id": "initialLoader"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-row', {
    staticStyle: {
      "align-items": "center"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "100",
      "tablet": "100"
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments)
      }
    }
  }, [_vm._l((_vm.goals), function(goal, index) {
    return _c('div', {
      key: ("goal-" + index)
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.activeStep),
        expression: "index === activeStep"
      }],
      staticClass: "step-content"
    }, [_c('p', {
      staticClass: "bigTxt"
    }, [_vm._v("Goal " + _vm._s(index + 1) + "/" + _vm._s(_vm.goals.length))]), _vm._v(" "), _c('p', {
      staticClass: "bigTxt"
    }, [_vm._v("\n            When you first began the program, you told us you wanted to "), _c('strong', {
      domProps: {
        "textContent": _vm._s(goal.goal)
      }
    }), _vm._v(" and rated yourself a "), _c('strong', {
      domProps: {
        "textContent": _vm._s(_vm.evaluation.old)
      }
    }), _vm._v(" out of 10 in regards to reaching this goal.\n          ")]), _vm._v(" "), _c('p', {
      staticClass: "bigTxt"
    }, [_vm._v("How do you feel like you’re doing now?")]), _vm._v(" "), _c('div', {
      staticClass: "sliderWrap"
    }, [_c('mu-slider', {
      staticClass: "slider",
      attrs: {
        "min": _vm.slider.min,
        "step": _vm.slider.step,
        "max": _vm.slider.max
      },
      model: {
        value: (_vm.evaluation.now),
        callback: function($$v) {
          _vm.$set(_vm.evaluation, "now", $$v)
        },
        expression: "evaluation.now"
      }
    }), _vm._v(" "), _c('mu-row', [_c('mu-col', {
      staticClass: "sliderLabel amount",
      attrs: {
        "width": "33",
        "desktop": "33",
        "tablet": "33"
      },
      domProps: {
        "textContent": _vm._s(_vm.slider.min)
      }
    }), _vm._v(" "), _c('mu-col', {
      attrs: {
        "width": "33",
        "desktop": "33",
        "tablet": "33"
      }
    }), _vm._v(" "), _c('mu-col', {
      staticClass: "sliderLabel amount",
      attrs: {
        "width": "33",
        "desktop": "33",
        "tablet": "33"
      },
      domProps: {
        "textContent": _vm._s(_vm.slider.max)
      }
    })], 1)], 1)])])
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "disabled": _vm.isProcessing || _vm.isFinished,
      "type": "button",
      "label": _vm.isProcessing ? _vm.$t('message.savingText') : (_vm.isLastPanel ? _vm.$t('message.saveText') : _vm.$t('message.nextText')),
      "secondary": "",
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleNext.apply(null, arguments)
      }
    }
  })], 2)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e97156b4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CheckIn/Goals.vue
// module id = 3861
// module chunks = 1